import { render, staticRenderFns } from "./T-F-Grad-2023.vue?vue&type=template&id=01c2c1bc&scoped=true&"
import script from "./T-F-Grad-2023.vue?vue&type=script&lang=js&"
export * from "./T-F-Grad-2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2c1bc",
  null
  
)

export default component.exports